var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCase(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 505 505",
    style: {
      enableBackground: "new 0 0 505 505"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFD05B"
    },
    cx: 252.5,
    cy: 252.5,
    r: 252.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 255.6,
    style: {
      fill: "#324A5E"
    },
    width: 321,
    height: 120.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 240.4,
    style: {
      fill: "#2B3B4E"
    },
    width: 321,
    height: 45.8
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#324A5E"
    },
    d: "M85.8,139.6V235c0,4.5,2.4,8.7,6.3,10.9c139.3,78.1,286.6,16,320.1-0.1c4.3-2.1,7-6.4,7-11.2v-94.9 H85.8V139.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#334A5E"
    },
    d: "M323.8,139.6h-20.5v-21.8H201.8v21.8h-20.5v-22.4c0-11,8.9-19.9,19.9-19.9h102.6 c11,0,19.9,8.9,19.9,19.9v22.4H323.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 263.2,
    style: {
      fill: "#4CDBC4"
    },
    width: 57,
    height: 40.9
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCase);
export default __webpack_public_path__ + "static/media/case.70c0e97a.svg";
export { ForwardRef as ReactComponent };